module.exports = require('./helpers/bundle-url').getBundleURL('hyeyu') + "../cluster-pin.5df8d604.svg";